// frontend/src/components/session/SessionExpiredModal.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { onSessionExpired } from "../../util/auth_events";
import { logoutUser, clearSessionExpired } from "../../actions/session_actions";
import "./sessionExpiredModal.css";

export default function SessionExpiredModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("expired");

  useEffect(() => {
  if (!open) return;
  document.body.classList.add("session-expired-open");
  return () => document.body.classList.remove("session-expired-open");
}, [open]);


  useEffect(() => {
    // Listen for the global session-expired event
    return onSessionExpired((r) => {
      setReason(r || "expired");
      setOpen(true);
    });
  }, []);

  // Optional: allow ESC to dismiss (does not restore auth)
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  const { title, message, sub } = useMemo(() => {
    const is401 = reason === "401";
    return {
      title: is401 ? "Session ended" : "Session expired",
      message: "For your security, your session has ended and you've been signed out. Please log in again to continue.",
      sub: "After you log in, we’ll bring you right back to where you left off.",
    };
  }, [reason]);

  if (!open) return null;

  const goToLogin = () => {
    // Clear redux auth so AuthRoute doesn't bounce back to dashboard
    dispatch(logoutUser());           // sets isAuthenticated false, user null
    dispatch(clearSessionExpired());  // clears soft-expire flag/reason
    setOpen(false);

    // HashRouter: always use "#/login"
    window.location.hash = "#/login";
  };

  

  return (
    <div
      className="session-expired-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Session expired"

    >
      <div className="session-expired-card" onMouseDown={(e) => e.stopPropagation()}>
        <div className="session-expired-title">{title}</div>
        <div className="session-expired-body">{message}</div>
        <div className="session-expired-sub">{sub}</div>

        <div className="session-expired-actions">
          <button
            type="button"
            className="session-expired-btn session-expired-btn-primary"
            onClick={goToLogin}
          >
            Log in
          </button>
        </div>
      </div>
    </div>
  );
}
